import React from "react";
import { Typography } from "@mui/material";
import moment from "moment";

interface SpeakerProps {
  timestamp?: string;
  timeClass?: string;
}

const SpeakerTimestamp: React.FC<SpeakerProps> = ({ timestamp, timeClass }) => {
  const formatTimestamp = (timestamp: string): string => {
    try {
      // Parse the UTC timestamp using moment
      const utcMoment = moment.utc(timestamp);

      // Convert the UTC moment to the user's local timezone
      const localMoment = utcMoment.local();

      // Format the time in 24-hour format
      const timeString = localMoment.format("HH:mm:ss");

      // Format the date as "DD-MMM-YYYY"
      const dateString = localMoment.format("DD-MMM-YYYY");

      return `${timeString} (${dateString})`;
    } catch (error) {
      console.error("Error formatting timestamp:", error);
      return "Invalid timestamp";
    }
  };

  return (
    <Typography
      variant='subtitle2'
      className={timeClass ? timeClass : "speaker-info"}
    >
      {timestamp ? `${formatTimestamp(timestamp)}` : ""}
    </Typography>
  );
};

export default SpeakerTimestamp;
